












import { Component } from '@niknevis/vue-modules'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'

@Component({
  components: {
    TesTd
  }
})
export default class TesTableCell extends Vue {
  @Prop() targetComponent!: any
  @Prop() targetComponentProps!: object
  @Prop() props!: any
  @Prop() grid!: boolean
}
